<template>
  <a-modal
    title="主动好友招呼消息"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="table-operator">
      <a-button type="primary" @click="$refs.addRepeatZhaohuModal.show()">重复添加回复</a-button>
      <a-alert
        style="margin-top: 10px"
        show-icon
        type="warning"
        message="请勿使用英文字符，否则不发送打招呼消息"
      ></a-alert>
    </div>
    <a-table :columns="columns" :dataSource="data" :pagination="false" rowKey="id">
      <span slot="type" slot-scope="text">
        {{ text | typeFilter }}
      </span>
      <span slot="content" slot-scope="text, record">
        <template v-if="record.type == '1'">
          <span v-line-clamp="1">{{ text }}</span>
        </template>
        <template v-if="record.type == '2'">
          <a :href="text | getQiniuUrl" target="_blank">查看图片</a>
        </template>
        <template v-if="record.type == '3'">
          <a :href="text | getQiniuUrl" target="_blank">查看视频</a>
        </template>
        <template v-if="record.type == '4'">
          <a :href="text | getQiniuUrl" target="_blank">查看动图</a>
        </template>
        <template v-if="record.type == '5'">
          <span v-line-clamp="1">
            {{ text | getKapianContent }}
          </span>
        </template>
      </span>
      <span slot="action" slot-scope="text, record">
        <template v-if="record.type == '1'">
          <a @click="handleEdit(record.id)">修改</a>
          <a-divider type="vertical" />
        </template>
        <a @click="handleDelete(record.id)">删除</a>
      </span>
    </a-table>
    <add-repeat-zhaohu-modal ref="addRepeatZhaohuModal" @ok="handleAdd"></add-repeat-zhaohu-modal>
    <edit-repeat-zhaohu-modal ref="editRepeatZhaohuModal" @ok="handleEditSuccess"></edit-repeat-zhaohu-modal>
  </a-modal>
</template>

<script>
const columns = [
  {
    title: '类型',
    dataIndex: 'type',
    scopedSlots: { customRender: 'type' },
  },
  {
    title: '回复内容',
    dataIndex: 'content',
    width: 500,
    scopedSlots: { customRender: 'content' },
  },
  {
    title: '操作',
    key: 'action',
    width: '110px',
    scopedSlots: { customRender: 'action' },
  },
]

const data = []

import { mapActions, mapGetters } from 'vuex'
import AddRepeatZhaohuModal from './AddRepeatZhaohuModal'
import EditRepeatZhaohuModal from './EdiRepeatZhaohuModal'
export default {
  components: {
    AddRepeatZhaohuModal,
    EditRepeatZhaohuModal,
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 },
      },
      visible: false,
      confirmLoading: false,
      data,
      columns,
    }
  },
  filters: {
    typeFilter(type) {
      if (type == '1') {
        return '文本消息'
      }
      if (type == '2') {
        return '图片消息'
      }
      if (type == '3') {
        return '视频消息'
      }
      if (type == '4') {
        return '动图消息'
      }
      if (type == '5') {
        return '卡片消息'
      }
    },
    getQiniuUrl(text) {
      if (typeof text === 'string') {
        const obj = JSON.parse(text)
        return `http://${obj.domain}/${obj.fkey}`
      } else if (typeof text === 'object') {
        return `http://${text.domain}/${text.fkey}`
      } else {
        return text
      }
    },
    getKapianContent (text) {
      const obj = JSON.parse(text)
      return `标题：${obj.title} 描述：${obj.des} 图片：${obj.img} 链接：${obj.url}`
    },
  },
  methods: {
    show(data) {
      if (data) {
        this.data = JSON.parse(data)
      }
      this.visible = true
    },
    handleOk() {
      this.$emit('ok', JSON.stringify(this.data))
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    },
    handleAdd({ id, type, content }) {
      this.data.push({
        id: id,
        type: type,
        content: content,
      })
    },
    handleDelete(id) {
      this.data = this.data.filter((val) => {
        return val.id != id
      })
    },
    handleEdit(id) {
      const obj = this.data.find((item) => {
        return item.id == id
      })
      this.$refs.editRepeatZhaohuModal.show(obj)
    },
    handleEditSuccess({ id, type, content }) {
      this.data = this.data.map((item) => {
        if (item.id == id) {
          item.content = content
        }
        return item
      })
    },
  },
}
</script>
<style lang="less" scoped>
.table-operator {
  margin-bottom: 10px;
}
</style>
